//
//  NotFound.tsx
//
//  isana.net,inc. Proprietary and Confidential
//
const NotFound: React.FunctionComponent = () => {
  return (
    <>
      <h1>Not Found</h1>
    </>
  );
};

export default NotFound;
